import React, { Component } from 'react';
import ReactModal from 'react-modal';
import { AcceptLink } from './AcceptLink';
import { CourseDetailsLink } from './CourseDetailsLink';

export class QuoteData extends Component {

    constructor () {
        super();
        this.state = {
            showModal: false,
            activeQuote: {},
            lineItems: []
        };
        
        this.handleLineAcceptTermsClick = this.handleLineAcceptTermsClick.bind(this);
        this.handleOpenModal = this.handleOpenModal.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
    }
    
    customModalStyles = {
        overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.75)'
        },
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            maxWidth: 800,
            maxHeight: 500,
            marginRight: '-50%',
            padding: 0,
            transform: 'translate(-50%, -50%)',
        },
    };

    componentDidMount() {
        this.setState({
            lineItems: this.props.quoteData.lineItems
        });
    }

    handleLineAcceptTermsClick(acceptCode) {
        const lineItemIndex = this.state.lineItems.findIndex(line => line.acceptCode === acceptCode);

        if (lineItemIndex >= 0) {
            const lineItems = this.state.lineItems;
                
                lineItems[lineItemIndex] = {
                    ...lineItems[lineItemIndex],
                    quoteAccepted: true
                };

            this.setState( { lineItems: lineItems});

            setTimeout(() => this.handleCloseModal(), 1000);
        }
    }

    handleOpenModal (activeQuote) {
        this.setState({ 
            activeQuote: activeQuote,
            showModal: true 
        });

        document.addEventListener('keydown', this.handleKeyDown);
    }

    handleCloseModal () {
        this.setState({ showModal: false });
        document.removeEventListener('keydown', this.handleKeyDown);
    }

    handleKeyDown(e) {
        if (e.keyCode === 27) {
            this.handleCloseModal();
        }
    }
    
    renderQuotes(quoteData) {

        const brandTermsUrl = `https://${quoteData.brandUrl}/${quoteData.brandTermsPage}`;
        const fullAcceptUrl = `${quoteData.quoteTargetUrl}${quoteData.acceptQuoteFunction}`;
        let agentName = '';

        if (quoteData.agentFirstName) {
            agentName = `${quoteData.agentFirstName} ${quoteData.agentLastName ? quoteData.agentLastName : ''} - Sales Agent`;
        } else {
            agentName = `${quoteData.brandName} Sales`;
        }

        return (
            <div>
            <table className='table table-striped table-bordered'>
                <thead>
                    <tr>
                        <th>Training Course</th>
                        <th>Delegates</th>
                        <th>Cost (ex. VAT)</th>
                        <th>Accept</th>
                    </tr>
                </thead>
                <tbody>
                    {quoteData.lineItems.map(quote =>
                        (<tr key={quote.acceptCode}>
                            <td>{quote.productName}<CourseDetailsLink documentLocation={quote.documentUrl}/></td>
                            <td>{quote.delegates}</td>
                            <td>£{quote.amountExVat.toFixed(2)}</td>
                            <td>
                                {!quote.quoteAccepted
                                    ? <button className="btn btn-primary hidden-print" onClick={(e) => this.handleOpenModal(quote)}>Click to Accept</button>
                                    : <button className="btn btn-default disabled hidden-print">Accepted</button>}
                            </td>
                        </tr>)
                    )}
                </tbody>
                </table>
                <div className="text-info hidden-print">
                    <blockquote className="text-info">
                        <em><small>
                            Thank you for talking to me earlier.<br />
                            I hope this quotation meets your requirements. If so, please click on the Accept button(s) to proceed. I'll then call you back to confirm your booking and arrange the training.<br /><br/>
                            Kind regards<br/>
                            {agentName}
                        </small></em>
                    </blockquote>
                </div>
                <ReactModal 
                    isOpen={this.state.showModal}
                    contentLabel="Terms of agreement"
                    style={this.customModalStyles}>

                    <button onClick={this.handleCloseModal} style={{position: 'absolute', top: 10, right: 10, border: 'none', backgroundColor: 'transparent'}}>
                        <span className="glyphicon glyphicon-remove" aria-hidden="true"></span>
                    </button>

                    <div style={{margin: 20, padding: 30, textAlign: 'center' }}>
                        <h3 style={{}}>Order Confirmation</h3>
                        <p>By clicking this button, you accept our {brandTermsUrl ? (
                            <a href={brandTermsUrl} target="_blank" rel="noopener noreferrer">terms of business</a>
                        ) : (
                            <span>terms of business</span>
                        )}.
                        </p>
                        <div style={{marginTop: 25, marginBottom: 25, textAlign: 'center'}}>
                            <AcceptLink onAccept={this.handleLineAcceptTermsClick} acceptUrl={fullAcceptUrl} acceptCode={this.state.activeQuote.acceptCode} accepted={this.state.activeQuote.quoteAccepted} />
                        </div>
                        <p>Our office hours are Monday to Thursday 8:30am-5:00pm,<br />and Friday 8:30am-3:45pm.</p>
                        <p>If you accept your quote outside of these hours, a member<br />of our team will contact you on the next working day.</p>
                    </div>
                </ReactModal>
            </div>
        );
    }
  
    render() {
        return this.renderQuotes(this.props.quoteData);
    }
}